<template>
  <WebPanelPage class="ui-buttons-route" title="Buttons">
    <div class="flex mb5">
      <BreadcrumbNav
        :items="[
          { name: 'UI Components', routerLink: { name: 'ui-index' } },
          { name: 'Buttons' },
        ]"
      ></BreadcrumbNav>
    </div>
    <div>
      <ComponentShowcase
        title="Default"
        :showcaseComponent="$options.components.UIButton"
      >Click me !</ComponentShowcase>
      <ComponentShowcase
        title="Secondary"
        :showcaseComponent="$options.components.UIButton"
        :props="{
          secondary: true
        }"
      >Click me !</ComponentShowcase>
      <ComponentShowcase
        title="Ghost"
        :showcaseComponent="$options.components.UIButton"
        :props="{
          ghost: true
        }"
      >Click me !</ComponentShowcase>
      <ComponentShowcase
        title="Tiny"
        :showcaseComponent="$options.components.UIButton"
        :props="{
          tiny: true
        }"
      >Click me !</ComponentShowcase>
      <ComponentShowcase
        title="Tiny with icon"
        :showcaseComponent="$options.components.UIButton"
        :props="{
          tiny: true,
          icon: 'trash'
        }"
      >Click me !</ComponentShowcase>
      <ComponentShowcase
        title="Tiny secondary"
        :showcaseComponent="$options.components.UIButton"
        :props="{
          tiny: true,
          secondary: true,
        }"
      >Click me !</ComponentShowcase>
      <ComponentShowcase
        title="Link style"
        :showcaseComponent="$options.components.UIButton"
        :props="{
          link: true,
        }"
      >Click me !</ComponentShowcase>
      <ComponentShowcase
        title="Warning style"
        :showcaseComponent="$options.components.UIButton"
        :props="{
          warning: true,
          icon: 'alert-triangle-fill'
        }"
      >Click me !</ComponentShowcase>
      <ComponentShowcase
        title="Unstyled"
        :showcaseComponent="$options.components.UIButton"
        :props="{
          unstyled: true,
        }"
      >Click me !</ComponentShowcase>
    </div>
  </WebPanelPage>
</template>
<script>
import BreadcrumbNav from '@sbvr/common/legacy-shared/components/BreadcrumbNav';
import WebPanelPage from '@sbvr/web-panel/WebPanelPage';
import ComponentShowcase from './components/ComponentShowcase';
import UIButton from '@sbvr/ui/UIButton';

export default {
  name: 'UIButtonsRoute',
  components: {
    WebPanelPage,
    BreadcrumbNav,
    ComponentShowcase,
    UIButton, //eslint-disable-line
  },
};
</script>

<style lang="postcss" scoped>
.devices-show-route {
  @apply --container;
  padding-top: var(--spacingMd);
}
</style>
